export default {"src":"/_next/static/media/gramax-logo-desktop-dark.d8bbcd45.svg","height":32,"width":86,"blurWidth":0,"blurHeight":0};